import { useWatch } from '@vtex/admin-ui-form'
import { useMemo, useState } from 'react'
import { useDrawerState, useFormStateContext } from 'ui'
import { RegularScopeApplyTo, type RegularEffect } from '../../../../../typings'
import { RegularScopeEditor } from './Editor'
import { RegularScopeView } from './View'
import { EMPTY_SCOPE } from './constants'
import { SCOPE_OPTIONS } from '../../../../ItemsView/typing'

type Props = {
  name: string
}

export function RegularScope(props: Props) {
  const { name } = props

  const drawerState = useDrawerState()

  const { form } = useFormStateContext()

  const scope: RegularEffect['scope'] = useWatch({ name, form })

  const config = useMemo(
    () =>
      scope ?? { ...EMPTY_SCOPE, applyTo: RegularScopeApplyTo.filteredItems },
    [scope]
  )

  const [selectedOption, setSelectedOption] = useState<
    SCOPE_OPTIONS | undefined
  >(undefined)

  const handleSave = (config: RegularEffect['scope']) => {
    form.setValue(name, config)
    form.clearErrors(name)
  }

  return (
    <>
      <RegularScopeView
        name={name}
        config={scope}
        onAdd={(option) => {
          setSelectedOption(option)
          drawerState.show()
        }}
        onRemove={(config) => form.setValue(name, config)}
      />
      <RegularScopeEditor
        name={name}
        config={config}
        state={drawerState}
        onSave={handleSave}
        selectedOption={selectedOption}
      />
    </>
  )
}
